import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import { setSelectionRequest } from "@tvg/desktop-bet/src/store/actions";
import { RaceWagerType } from "@tvg/ts-types/Race";
import { Button } from "@tvg/design-system";
import ListViewFilter from "../../../../ListViewFilter";
import { ButtonContainer, Container } from "./styled-components";
import { filterSelectAllLabels, getPosition } from "../utils/utils";

interface MobileDropdownSelectionsProps {
  selectionLabels: Array<string>;
  betType: RaceWagerType;
  isAllSelected: boolean[];
  onClickSelectAll: (position: number, isAllSelected: boolean) => void;
  isScrollableRacecard?: boolean;
  leg?: number;
}

const MobileDropdownSelections = ({
  selectionLabels,
  betType,
  isAllSelected,
  onClickSelectAll,
  isScrollableRacecard,
  leg = 0
}: MobileDropdownSelectionsProps) => {
  const dispatch = useDispatch();
  const hasOneAllSelected: boolean =
    isAllSelected && isAllSelected.includes(true);

  const filterOptions = useMemo(
    () =>
      selectionLabels.map((item, index) => ({
        label: item,
        value: item,
        isActive: isAllSelected[index]
      })),
    [selectionLabels]
  );

  const selectAllLabels =
    selectionLabels &&
    betType &&
    filterSelectAllLabels(selectionLabels, betType);

  return (
    <Container data-qa-label="dropdown-select-all-container">
      {selectAllLabels?.length > 1 && selectionLabels?.length > 1 ? (
        <ListViewFilter
          modalTitle="Select all"
          button={{
            text: "Select all",
            qaLabel: "simple-select-all-button",
            icon: "chevronDown",
            iconPosition: "end",
            isActive: hasOneAllSelected
          }}
          onChange={(value) => {
            const index = filterOptions.findIndex(
              (option) => option.value === value
            );
            onClickSelectAll(index, isAllSelected[index as number]);
          }}
          filterOptions={filterOptions}
          leftButtonText="Reset"
          onClickLeftButton={() => dispatch(setSelectionRequest([]))}
        />
      ) : (
        selectAllLabels?.map((label, index: number) => {
          const position = isScrollableRacecard ? leg : index;
          return (
            <ButtonContainer
              key={`${label}-${betType.type.code}-selection`}
              isActive={isAllSelected[position]}
            >
              <Button
                size="m"
                variant="tertiary"
                qaLabel="simple-select-all-button"
                onPress={() =>
                  onClickSelectAll(
                    getPosition(position, betType),
                    isAllSelected[position]
                  )
                }
              >
                Select all
              </Button>
            </ButtonContainer>
          );
        })
      )}
    </Container>
  );
};

export default MobileDropdownSelections;
